import { useDragDropUploadContext } from 'context/DragDropUpload'

import { translate } from 'utils/translations'
import Text from 'common-components/Text'

import * as Styled from './styled'
import { T } from 'consts/translationKeys'

export const DragAreaActiveContent: React.FC = () => {
  const { dragDropUploadData } = useDragDropUploadContext()
  const { isDragActive } = dragDropUploadData
  return isDragActive ? (
    <Styled.DragAreaActiveWrapper>
      <Text type="h2" color="primaryDark">
        {translate(T.YES_DROP_IT)}
      </Text>
    </Styled.DragAreaActiveWrapper>
  ) : null
}
